import React from 'react';

import LocationInput2 from '~/components/common/LocationInput2';

import css from '../index.css';

const PlaceInputWrap = (props) => {
  const {id, onChange, onBlur, formError} = props;
  return (
    <div className={css.left}>
      <LocationInput2
        id={`${id}-origin`}
        data-qa={`${id}-origin`}
        label='ORIGIN'
        name='origin'
        placeholder='City'
        icon={'greenPlace'}
        autoComplete = 'off'
        iconLeft={true}
        touched={true}
        onChange = {onChange}
        onBlur = {onBlur}
        error={formError.origin ? formError.origin : ' '}
      />
      <LocationInput2
        id={`${id}-destination`}
        data-qa={`${id}-destination`}
        label='DESTINATION'
        icon={'bluePlace'}
        name='destination'
        iconLeft={true}
        autoComplete = 'off'
        touched={true}
        placeholder='City'
        onChange = {onChange}
        onBlur = {onBlur}
        error={formError.destination ? formError.destination : ' '}
      />
    </div>
  );
};

export default PlaceInputWrap;



// WEBPACK FOOTER //
// ./src/components/rate/AddressAndEqipInfo/PlaceInputWrap/index.js